@if (metaFieldKeys().length) {
  <section class="section-outset-y container px-4 px-md-0">
    <h2 class="h4">{{ 'agenda-detail-meta-titel' | fromDictionary }}</h2>

    @if ('agenda-detail-meta-tekst' | fromDictionary: false) {
      <p>{{ 'agenda-detail-meta-tekst' | fromDictionary }}</p>
    }

    <ul class="meta-list mt-4" [style.--list-lenght]="metaFieldKeys().length">
      @for (key of metaFieldKeys(); track $index) {
        <li class="meta-list__item">
          <strong>{{ 'agenda-detail-meta-' + metaField(key).dict | fromDictionary }}</strong>

          <ul>
            @for (field of metaField(key).items; track $index) {
              <li>
                <a class="meta-link" [routerLink]="['/agenda']" [queryParams]="filterParam(key, field.id)">
                  {{ field?.name }}
                </a>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </section>
}
